import 'styles/age_verification/address-form.scss';

import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import AddressFields from './AddressFields';
import { addressValidate } from './validations';
import BaseAddressForm from './BaseAddressForm';
import ConfirmationModal from './ConfirmationModal';
import DobFieldGroup from './DobFieldGroup';
import {
  getConfirmValues,
  getSsnOptoutValue,
  getDobValues,
} from '../../selectors';
import LogOutLink from '../LogOutLink';
import NameFieldGroup from './NameFieldGroup';
import PropTypes from '../../propTypes';
import SSNFieldGroup from './SSNFieldGroup';
import { TranslatedMessage, TRANSLATED_CLASS } from 'common/components/Intl';

import * as f from 'common/components/Form';
import * as m from '../../messages';

const FULL = 'full';
const ALTERNATE = 'alternate';

export class AddressForm extends BaseAddressForm {
  static propTypes = {
    confirmSubmit: PropTypes.bool,
    confirmValues: PropTypes.object,
    descriptionMessageId: PropTypes.string,
    disableNameFields: PropTypes.bool,
    dobValues: PropTypes.object,
    initialValues: PropTypes.object,
    layout: PropTypes.oneOf([FULL, ALTERNATE]),
    minPurchaseAge: PropTypes.number,
    minRequiredAge: PropTypes.number,
    showAddressFields: PropTypes.bool,
    showDobFields: PropTypes.bool,
    showNameHeading: PropTypes.bool,
    showSSNFields: PropTypes.bool,
    ssnOptoutEnabled: PropTypes.bool,
    ssn_optout: PropTypes.bool,
    titleMessageId: PropTypes.string,
  };

  renderNameFields() {
    return (
      <NameFieldGroup
        showHeading={this.props.showNameHeading}
        disabled={this.props.disableNameFields}
      />
    );
  }

  render() {
    const { country } = this.props.initialValues || {};

    return (
      <div>
        <f.Form className="AddressForm" onSubmit={this.submitHandler}>
          {this.props.showDobFields && (
            <DobFieldGroup
              selectedValues={this.props.dobValues}
              minRequiredAge={this.props.minRequiredAge}
              minPurchaseAge={this.props.minPurchaseAge}
            />
          )}

          {this.props.layout == FULL && this.renderNameFields()}

          <div className="AddressForm__group">
            {this.props.titleMessageId &&
              this.props.descriptionMessageId && (
                <React.Fragment>
                  <div className="subhead navy">
                    <TranslatedMessage id={this.props.titleMessageId} />
                  </div>
                  <p className="text flat-blue">
                    <TranslatedMessage id={this.props.descriptionMessageId} />
                  </p>
                </React.Fragment>
              )}

            {this.props.layout == ALTERNATE && this.renderNameFields()}

            {this.props.showAddressFields && (
              <AddressFields
                country={country}
                fieldsMeta={this.props.addressFieldsMeta}
                onAddressSelect={this.onAddressSelect}
                selectedState={this.state.selectedState}
              />
            )}
          </div>

          {this.props.showSSNFields && (
            <SSNFieldGroup
              disabled={this.props.ssn_optout}
              optOutEnabled={this.props.ssnOptoutEnabled}
            />
          )}

          {this.props.error && (
            <div
              id="errors"
              className={classNames('red label', TRANSLATED_CLASS)}
            >
              {this.props.error}
            </div>
          )}

          <f.Submit
            className="AddressForm__submit"
            isSubmitting={this.props.submitting}
          >
            <TranslatedMessage id={m.ADDRESS_SUBMIT} />
          </f.Submit>
          <LogOutLink />
        </f.Form>

        {!this.props.pristine &&
          this.props.confirmSubmit && (
            <ConfirmationModal
              isOpen={this.state.modalIsOpen}
              formValues={this.props.confirmValues}
              onConfirm={this.onConfirm.bind(this)}
              onClose={this.hideConfirmationModal.bind(this)}
            />
          )}
      </div>
    );
  }
}

const Form = reduxForm({
  form: 'age_verification',
  validate: addressValidate,
})(AddressForm);

// Decorate with connect to read form values to be used by confirmation dialog
// and ssn disabling.
export default connect(state => ({
  confirmValues: getConfirmValues(state, 'age_verification'),
  ssn_optout: getSsnOptoutValue(state, 'age_verification'),
  dobValues: getDobValues(state, 'age_verification'),
}))(Form);



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/AddressForm.js